import { Stack, IconButton, Box, Chip, Typography, Link } from '@mui/material';

type Props = {
  videoUrl: string;
  muted: boolean;
  setMuted: (muted: boolean) => void;
};

function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
}

export function VolumeControls({ videoUrl, muted, setMuted }: Props) {
  const isTouch = isTouchDevice();
  return (
    <Stack
      id="volume-controls"
      direction="row"
      spacing={1}
      alignItems="center"
      sx={{
        position: 'absolute',
        top: '16px',
        left: '16px',
        padding: '2px',
        zIndex: 99,
        background: 'rgba(0,0,0,0.4)',
        borderRadius: '50px',
        opacity: isTouch ? 1 : 0,
      }}
    >
      <IconButton
        sx={{
          color: '#fff',
          transition: 'all 0.3s ease-in-out',
          height: '37px',
          width: '37px',
          '&:hover': {
            background: 'rgba(0,0,0,0.4)',
          },
        }}
        onClick={() => setMuted(!muted)}
      >
        <i className={`far ${muted ? 'fa-volume-slash' : 'fa-volume'} fa-fw`} />
      </IconButton>
      <Box>
        <Chip
          component={Link}
          target="_blank"
          href={videoUrl}
          sx={{
            boxShadow: 'none',
            color: '#fff',
            fontWeight: 'bolder',
            cursor: 'pointer',
            background: 'transparent',
            transition: 'all 0.3s ease-in-out',
            height: '37px',
            borderRadius: '50px',

            '&:hover': {
              textDecoration: 'none',
              color: '#fff',
              background: 'rgba(0,0,0,0.4)',
            },
          }}
          label={
            <Stack direction="row" alignItems="center">
              <Box
                sx={{
                  fontSize: '15px',
                }}
              >
                <i className="fas fa-arrow-up-right-from-square fa-fw" />
              </Box>
              <Typography variant="body1" sx={{ color: '#fff', mx: 1 }}>
                Open
              </Typography>
            </Stack>
          }
        />
      </Box>
    </Stack>
  );
}
